// extracted by mini-css-extract-plugin
module.exports = {"TestsList":"fTYYktB4mmC7i9A-iSp6R","TestItems":"_2G5YKzotFEdJFcxvkOv2ko","Title":"_2EGXr9bnMdFQ-HuZ1u_QkS","Loader":"QexjE6u5kZoYDKp5nYbC9"};